import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },

    formGroup: {
      margin: '32px 0 0 16px',
    },
    formLabel: {
      marginTop: 5,
      marginBottom: 5,
    },
    switchText: { fontSize: 12, fontWeight: 500 },
    switchOption: {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
    },
  });
